import { RequestStatus } from '@opengov/app-core/transport';
import { composeInitialState } from '@opengov/compose-app';
import { EmptyListOf, mergeListsById } from '@opengov/compose-app/immutable';
import { List } from 'immutable';
import { IReport, IReportDatasetLens, IReportGalleryFilters, IReportGalleryPagination } from '@opengov/reporting-types';
import { IReportCreator } from '@opengov/api-deprecated';

import { IToastMuiProps, mergeReportCreatorListByUuid, mergeReportListsById } from '../../helpers/utils';
import { composeStateMachine } from '../../../../module';
import { Report, ReportCreator, ReportDatasetLens, ReportGalleryFilters, ReportGalleryPagination } from '../records';

export const muiToastInitialState: { props: IToastMuiProps | null } = {
  props: null
};

export const ReportInitialState = composeInitialState({
  reports: EmptyListOf(Report),
  filters: ReportGalleryFilters(),
  pagination: ReportGalleryPagination(),
  loadingReports: RequestStatus({ active: true }),
  loadingReport: RequestStatus(),
  reportCreators: EmptyListOf(ReportCreator),
  dataLenses: EmptyListOf(ReportDatasetLens),
  loadingDataLenses: RequestStatus(),
  muiToast: muiToastInitialState
});

export const reportState = composeStateMachine('reports', ReportInitialState, (compose) => ({
  // Reports -------------------------------------------------------------------------
  loadReports: compose.payloadlessAction((state) => state.set('loadingReports', RequestStatus({ active: true }))),

  loadReportsSuccess: compose.action((state, payload: IReport[]) =>
    state
      .set('loadingReports', RequestStatus())
      .set('reports', mergeReportListsById(state.reports, List(payload.map(Report))))
  ),

  loadReportsError: compose.action((state, error: any) => state.set('loadingReports', RequestStatus({ error }))),

  setFilters: compose.action((state, payload: IReportGalleryFilters) =>
    state.set('filters', ReportGalleryFilters(payload))
  ),

  setPagination: compose.action((state, payload: IReportGalleryPagination) =>
    state.set('pagination', ReportGalleryPagination(payload))
  ),

  loadReportCreatorsSuccess: compose.action((state, payload: IReportCreator[]) =>
    state.set('reportCreators', mergeReportCreatorListByUuid(state.reportCreators, List(payload.map(ReportCreator))))
  ),

  loadDataLensesSuccess: compose.action((state, payload: IReportDatasetLens[]) =>
    state
      .set('dataLenses', mergeListsById(state.dataLenses, List(payload.map(ReportDatasetLens))))
      .set('loadingDataLenses', RequestStatus())
  ),

  setLoadingLenses: compose.payloadlessAction((state) =>
    state.set('loadingDataLenses', RequestStatus({ active: true }))
  ),
  setLoadingLensesError: compose.action((state, error: any) =>
    state.set('loadingDataLenses', RequestStatus({ error }))
  ),

  // Report -------------------------------------------------------------------------
  loadReport: compose.payloadlessAction((state) => state.set('loadingReport', RequestStatus({ active: true }))),

  loadReportSuccess: compose.action((state, payload: IReport) =>
    state.set('loadingReport', RequestStatus()).set(
      'reports',
      state
        .get('reports', List())
        .filter((r) => r.id !== payload.id)
        .push(Report(payload))
    )
  ),

  loadReportError: compose.action((state, error: any) => state.set('loadingReport', RequestStatus({ error }))),

  deleteReportError: compose.action((state, error: any) => state.set('loadingReport', RequestStatus({ error }))),

  deleteReportSuccess: compose.action((state, payload: IReport) =>
    state.update('reports', (arr) => arr.filter((d) => d.id !== payload.id))
  ),
  setDefaultSavedViewId: compose.action((state, payload: { reportId: string; defaultSavedViewId: string | null }) =>
    state.update('reports', (reports) =>
      reports.map((r) => (r.id === payload.reportId ? r.set('defaultSavedViewId', payload.defaultSavedViewId) : r))
    )
  ),
  toggleMuiToast: compose.action((state, muiToastProps: IToastMuiProps | null) =>
    state.set('muiToast', { props: muiToastProps })
  )
}));

export const {
  actions: reportActions,
  actionCreators: reportActionCreators,
  selector: reportSelector,
  reducer: reportReducer
} = reportState;
